"use strict";

theme.ShoppableImage = (function () {
  function ShoppableImage(container) {
    this.container = container;
    this.namespace = ".shoppable-image-" + container.getAttribute("data-section-id");
    this.points = [].slice.call(container.querySelectorAll(".shoppable-point"));

    theme.loadImageSection(container);

    if (!this.points.length) {
      return;
    }

    this.points.forEach(
      function (point) {
        var dot = point.querySelector(".shoppable-point__dot");
        var closeBtn = point.querySelector(".shoppable-point__card-close");

        if (dot) {
          dot.addEventListener(
            "click",
            function (evt) {
              evt.stopPropagation();
              var isOpen = point.classList.contains("is-active");
              this.closeAll();
              if (!isOpen) {
                this.open(point);
              }
            }.bind(this),
          );
        }

        if (closeBtn) {
          closeBtn.addEventListener(
            "click",
            function (evt) {
              evt.stopPropagation();
              this.close(point);
            }.bind(this),
          );
        }
      }.bind(this),
    );

    window.on(
      "click" + this.namespace,
      function (evt) {
        if (!this.container.contains(evt.target)) {
          this.closeAll();
        }
      }.bind(this),
    );

    window.on(
      "keyup" + this.namespace,
      function (evt) {
        if (evt.key === "Escape") {
          this.closeAll();
        }
      }.bind(this),
    );
  }

  ShoppableImage.prototype = Object.assign({}, ShoppableImage.prototype, {
    open: function (point) {
      point.classList.add("is-active");
      var dot = point.querySelector(".shoppable-point__dot");
      if (dot) {
        dot.setAttribute("aria-expanded", "true");
      }
    },

    close: function (point) {
      point.classList.remove("is-active");
      var dot = point.querySelector(".shoppable-point__dot");
      if (dot) {
        dot.setAttribute("aria-expanded", "false");
      }
    },

    closeAll: function () {
      this.points.forEach(this.close.bind(this));
    },

    onBlockSelect: function (evt) {
      var point = this.container.querySelector(
        '.shoppable-point[data-block-id="' + evt.detail.blockId + '"]',
      );

      if (point) {
        this.closeAll();
        this.open(point);
        point.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },

    onBlockDeselect: function (evt) {
      var point = this.container.querySelector(
        '.shoppable-point[data-block-id="' + evt.detail.blockId + '"]',
      );

      if (point) {
        this.close(point);
      }
    },

    onUnload: function () {
      window.off("click" + this.namespace);
      window.off("keyup" + this.namespace);
    },
  });

  return ShoppableImage;
})();
